import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { ofType } from '@ngrx/effects';
import { ActionsSubject } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { invitation } from '../actions/invitations.actions';
import { GetInvitationDto } from '../dtos/getInvitationDto.interface';
import { InvitationProvider } from '../provider/invitation.provider';

@Injectable({
    providedIn: 'root',
})
export class GetInvitationResolver implements Resolve<GetInvitationDto> {
    constructor(
        private readonly invitationProvider: InvitationProvider,
        private readonly actionListener$: ActionsSubject,
        private readonly router: Router,
    ) {
        const language = localStorage.getItem('currentLanguage') || 'de-ch';
        this.actionListener$.pipe(ofType(invitation.getFailure), take(1)).subscribe((error) => {
            this.router.navigateByUrl(`${language}/auth/invitation-expired`);
            return;
        });
    }
    resolve(route: ActivatedRouteSnapshot): Observable<GetInvitationDto> {
        this.invitationProvider.dispatchGetInvitationByUuid(route.queryParamMap.get('invitation-uuid') as string);
        return this.invitationProvider.getInvitation$().pipe(
            filter((data: any) => data != null),
            take(1),
        );
    }
}
